module.exports = __webpack_public_path__ + "woff/OpenSans-CondBold-webfont.cc97fb.woff";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondBold-webfont.woff
 ** module id = 322
 ** module chunks = 12
 **/